// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Author_wrapper__Y8kcF","about":"Author_about__JFHgO","inner":"Author_inner___JpUL","backLink":"Author_backLink__9vb63"};